module.exports = __webpack_public_path__ + "assets/img/img-about-02.6dd62e0a.jpg";